export function getSortTriggerName(column: string): string {
  switch (column) {
    case 'apy':
    case 'tvl':
      return column.toUpperCase()
    default:
      return column
  }
}
